import SlotPicker from './SlotPicker.jsx';

export default function Field({ question, value, onChange, error }) {
  const { id, prompt, helper, type, options, rows, required, min } = question;
  const inputId = `q-${id}`;

  const labelEl = (
    <label htmlFor={inputId} className="field-label">
      {prompt}
      {required && <span className="field-required" aria-hidden="true"> *</span>}
    </label>
  );

  const helperEl = helper ? <div className="field-helper">{helper}</div> : null;
  const errorEl = error ? <div className="field-error">{error}</div> : null;

  if (type === 'textarea') {
    return (
      <div className="field">
        {labelEl}
        {helperEl}
        <textarea
          id={inputId}
          rows={rows || 4}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="field-input field-textarea"
        />
        {errorEl}
      </div>
    );
  }

  if (type === 'select') {
    return (
      <div className="field">
        {labelEl}
        {helperEl}
        <select
          id={inputId}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="field-input field-select"
        >
          <option value="" disabled>Choose one</option>
          {options.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
        </select>
        {errorEl}
      </div>
    );
  }

  if (type === 'multiselect') {
    const selected = Array.isArray(value) ? value : [];
    const toggle = (opt) => {
      if (selected.includes(opt)) {
        onChange(selected.filter((o) => o !== opt));
      } else {
        onChange([...selected, opt]);
      }
    };
    return (
      <div className="field" role="group" aria-labelledby={inputId}>
        <div id={inputId} className="field-label">
          {prompt}
          {required && <span className="field-required" aria-hidden="true"> *</span>}
        </div>
        {helperEl}
        <div className="field-chips">
          {options.map((opt) => {
            const on = selected.includes(opt);
            return (
              <button
                type="button"
                key={opt}
                onClick={() => toggle(opt)}
                className={`chip ${on ? 'chip-on' : ''}`}
                aria-pressed={on}
              >
                {opt}
              </button>
            );
          })}
        </div>
        {errorEl}
      </div>
    );
  }

  if (type === 'calendar') {
    return (
      <div className="field">
        {labelEl}
        {helperEl}
        <SlotPicker value={value} onChange={onChange} />
        {errorEl}
      </div>
    );
  }

  // text | email | tel | number
  return (
    <div className="field">
      {labelEl}
      {helperEl}
      <input
        id={inputId}
        type={type}
        min={min}
        value={value || ''}
        onChange={(e) => onChange(type === 'number' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value)}
        className="field-input"
      />
      {errorEl}
    </div>
  );
}
